import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'spSaveHtml',
})
export class SaveHtmlPipe implements PipeTransform {
  constructor(public readonly _sanitizer: DomSanitizer) {}

  public transform(html: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
}
